<template>
	<point-of-sale-edit
		v-if="resellerId"
		:reseller-id="resellerId"
	/>
</template>

<script>
import {
	axios,
} from '../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'ResellerPointOfSaleEdit',
	data () {
		return {
			resellerId: null,
		};
	},
	created () {
		this.getResellerId();
	},
	methods: {
		/**
		 * Get all reseller data.
		 *
		 * @returns {void}
		 */
		getResellerId () {
			axios.get(`/api/v0/users?id=${this.$userId}`)
				.then(({
					data: data
				}) => {
					this.resellerId = data[0].resellerusers[0].resellerId;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
				});
		},
	},
};
</script>
